module.exports = __webpack_public_path__ + "static/img/tenders_image.0efab08f.png";